import { Route } from '@angular/router';
import { RouteGuard } from '../auth/route.guard';
import { RoleCodes } from '@auth';

const adminRoutes: Route[] = [
  {
    path: 'admin',
    canActivate: [RouteGuard],
    loadChildren: () => import('./admin.module').then((m) => m.AdminModule),
    data: { roles: [RoleCodes.Admin] },
  },
];

export default adminRoutes;
